<template>
  <StatisticsHeader>
    <StatisticsPanel :load="load" v-slot="{ data }">
      <CollectionsStats :data="data" />
    </StatisticsPanel>
  </StatisticsHeader>
</template>

<script>
import StatisticsHeader from "@/statistics/components/StatisticsHeader.vue";
import StatisticsPanel from "@/statistics/components/StatisticsPanel.vue";
import CollectionsStats from "@/statistics/components/stats/CollectionsStats.vue";
import {StatisticsController} from "@/statistics/controllers/StatisticsController";

export default {
  name: 'StatisticsCollectionsView',
  components: {StatisticsHeader, StatisticsPanel, CollectionsStats},
  methods: {
    load: urlParams => StatisticsController.getCollections(urlParams),
  },
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

h1
  color: THEME_COLOR_PRIMARY
  span
    color: THEME_COLOR_PRIMARY_FADDED
</style>
